import styles from "./PixelLetters.module.css";

const A = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M1 0h2M0 1h1M3 1h1M0 2h1M3 2h1M0 3h4M0 4h1M3 4h1M0 5h1M3 5h1M0 6h1M3 6h1" />
  </svg>
);
const B = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h3M0 1h1M3 1h1M0 2h1M3 2h1M0 3h3M0 4h1M3 4h1M0 5h1M3 5h1M0 6h3" />
  </svg>
);

const C = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M1 0h2M0 1h1M3 1h1M0 2h1M0 3h1M0 4h1M0 5h1M3 5h1M1 6h2" />
  </svg>
);

const D = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h2M0 1h1M2 1h1M0 2h1M3 2h1M0 3h1M3 3h1M0 4h1M3 4h1M0 5h1M2 5h1M0 6h2" />
  </svg>
);

const E = () => (
  <svg
    className={`${styles.letter} ${styles.letter3}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 3 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h3M0 1h1M0 2h1M0 3h3M0 4h1M0 5h1M0 6h3" />
  </svg>
);

const F = () => (
  <svg
    className={`${styles.letter} ${styles.letter3}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 3 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h3M0 1h1M0 2h1M0 3h3M0 4h1M0 5h1M0 6h1" />
  </svg>
);

const G = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M1 0h2M0 1h1M3 1h1M0 2h1M0 3h1M0 4h1M2 4h2M0 5h1M3 5h1M1 6h2" />
  </svg>
);

const H = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h1M3 0h1M0 1h1M3 1h1M0 2h1M3 2h1M0 3h4M0 4h1M3 4h1M0 5h1M3 5h1M0 6h1M3 6h1" />
  </svg>
);

const I = () => (
  <svg
    className={`${styles.letter} ${styles.letter3}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 3 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h3M1 1h1M1 2h1M1 3h1M1 4h1M1 5h1M0 6h3" />
  </svg>
);

const J = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h4M2 1h1M2 2h1M2 3h1M2 4h1M0 5h1M2 5h1M1 6h2" />
  </svg>
);

const K = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h1M3 0h1M0 1h1M3 1h1M0 2h1M2 2h1M0 3h2M0 4h1M2 4h1M0 5h1M3 5h1M0 6h1M3 6h1" />
  </svg>
);

const L = () => (
  <svg
    className={`${styles.letter} ${styles.letter3}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 3 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h1M0 1h1M0 2h1M0 3h1M0 4h1M0 5h1M0 6h3" />
  </svg>
);

const M = () => (
  <svg
    className={`${styles.letter} ${styles.letter5}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 5 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h2M3 0h2M0 1h1M2 1h1M4 1h1M0 2h1M2 2h1M4 2h1M0 3h1M2 3h1M4 3h1M0 4h1M4 4h1M0 5h1M4 5h1M0 6h1M4 6h1" />
  </svg>
);

const N = () => (
  <svg
    className={`${styles.letter} ${styles.letter5}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 5 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h2M4 0h1M0 1h2M4 1h1M0 2h1M2 2h1M4 2h1M0 3h1M2 3h1M4 3h1M0 4h1M3 4h2M0 5h1M3 5h2M0 6h1M4 6h1" />
  </svg>
);

const O = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M1 0h2M0 1h1M3 1h1M0 2h1M3 2h1M0 3h1M3 3h1M0 4h1M3 4h1M0 5h1M3 5h1M1 6h2" />
  </svg>
);

const P = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h3M0 1h1M3 1h1M0 2h1M3 2h1M0 3h1M3 3h1M0 4h3M0 5h1M0 6h1" />
  </svg>
);

const Q = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M1 0h2M0 1h1M3 1h1M0 2h1M3 2h1M0 3h1M3 3h1M0 4h1M3 4h1M0 5h1M2 5h1M1 6h1M3 6h1" />
  </svg>
);

const R = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h3M0 1h1M3 1h1M0 2h1M3 2h1M0 3h1M3 3h1M0 4h3M0 5h1M3 5h1M0 6h1M3 6h1" />
  </svg>
);

const S = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M1 0h2M0 1h1M3 1h1M0 2h1M1 3h2M3 4h1M0 5h1M3 5h1M1 6h2" />
  </svg>
);

const T = () => (
  <svg
    className={`${styles.letter} ${styles.letter3}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 3 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h3M1 1h1M1 2h1M1 3h1M1 4h1M1 5h1M1 6h1" />
  </svg>
);

const U = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h1M3 0h1M0 1h1M3 1h1M0 2h1M3 2h1M0 3h1M3 3h1M0 4h1M3 4h1M0 5h1M3 5h1M1 6h2" />
  </svg>
);

const V = () => (
  <svg
    className={`${styles.letter} ${styles.letter5}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 5 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h1M4 0h1M0 1h1M4 1h1M0 2h1M4 2h1M1 3h1M3 3h1M1 4h1M3 4h1M1 5h1M3 5h1M2 6h1" />
  </svg>
);

const W = () => (
  <svg
    className={`${styles.letter} ${styles.letter5}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 5 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h1M4 0h1M0 1h1M4 1h1M0 2h1M4 2h1M0 3h1M2 3h1M4 3h1M0 4h1M2 4h1M4 4h1M0 5h1M2 5h1M4 5h1M1 6h1M3 6h1" />
  </svg>
);

const X = () => (
  <svg
    className={`${styles.letter} ${styles.letter5}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 5 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h1M4 0h1M0 1h1M4 1h1M1 2h1M3 2h1M2 3h1M1 4h1M3 4h1M0 5h1M4 5h1M0 6h1M4 6h1" />
  </svg>
);

const Y = () => (
  <svg
    className={`${styles.letter} ${styles.letter5}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 5 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h1M4 0h1M0 1h1M4 1h1M0 2h1M4 2h1M1 3h3M2 4h1M2 5h1M2 6h1" />
  </svg>
);

const Z = () => (
  <svg
    className={styles.letter}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 4 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h4M3 1h1M2 2h1M1 3h1M0 4h1M0 5h1M0 6h4" />
  </svg>
);

const Comma = () => (
  <svg
    className={`${styles.letter} ${styles.letter2}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 2 9"
    shapeRendering="crispEdges"
  >
    <path stroke="#9c9da8" d="M1 6h1" />
    <path d="M1 7h1M0 8h1" />
  </svg>
);

const ExclamationPoint = () => (
  <svg
    className={`${styles.letter} ${styles.letter1}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 1 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 0h1M0 1h1M0 2h1" />
    <path d="M0 3h1M0 4h1M0 6h1" />
  </svg>
);

const Period = () => (
  <svg
    className={`${styles.letter} ${styles.letter1}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 1 9"
    shapeRendering="crispEdges"
  >
    <path d="M0 6h1" />
  </svg>
);

const Dash = () => (
  <svg
    className={`${styles.letter} ${styles.letter3}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -0.5 5 12"
    shapeRendering="crispEdges"
  >
    <path stroke="#ffffff" d="M1 4h3" />
  </svg>
);

export const capitalLetterComponents = {
  A: <A />,
  B: <B />,
  C: <C />,
  D: <D />,
  E: <E />,
  F: <F />,
  G: <G />,
  H: <H />,
  I: <I />,
  J: <J />,
  K: <K />,
  L: <L />,
  M: <M />,
  N: <N />,
  O: <O />,
  P: <P />,
  Q: <Q />,
  R: <R />,
  S: <S />,
  T: <T />,
  U: <U />,
  V: <V />,
  W: <W />,
  X: <X />,
  Y: <Y />,
  Z: <Z />,
  ",": <Comma />,
  ".": <Period />,
  "!": <ExclamationPoint />,
  "-": <Dash />,
};
